/** Muestreo aleatorio reproducible en cliente (comentarios tipo “random”). */

export function shuffleInPlace<T>(items: T[]): T[] {
  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const t = items[i]!;
    items[i] = items[j]!;
    items[j] = t;
  }
  return items;
}

/** Copia y devuelve hasta `count` elementos distintos en orden aleatorio. */
export function sampleUnique<T>(items: readonly T[], count: number): T[] {
  const copy = [...items];
  shuffleInPlace(copy);
  return copy.slice(0, Math.min(count, copy.length));
}
